<template>

    <v-radio-group class="compact" outlined 
        :value="value[schema.name]" :mandatory="false" :label="schema.label"
        @change="$emit('change', $event)" hide-details
    >
        <v-radio v-for="(item, index) in schema.items" :label="item.text || item.value" :value="item.value || item.text" :key="index"></v-radio>
    </v-radio-group>

</template>

<script>



export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: Object,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// RadioControl.vue?51df520f